import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { OmbudsRapporteringPage } from "pages/app/naturvardsverket/ombuds-rapportering/OmbudsRapporteringPage";
import { getWaste } from "api/waste.api";

const ombudsRapporteringSearchSchema = z.object({
  wasteid: z.number().int().positive().optional().catch(undefined),
});

export const Route = createFileRoute(
  "/_authenticated/app/avfallsregistret/rapportera-som-ombud",
)({
  validateSearch: ombudsRapporteringSearchSchema,
  beforeLoad: async ({ context: { queryClient }, search }) => {
    if (search.wasteid) {
      await queryClient.ensureQueryData(getWaste(search.wasteid));
    }
  },
  component: OmbudsRapporteringPage,
});
